import { DatePicker, Typography } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import CalendarIcon from "@/shared/assets/svg/icons/calendar-icon.png";
import "./custom-date-picker.scss";

export const CustomDatePicker = ({
  name,
  label,
  disableBefore,
  disabled,
}: {
  name: string;
  label: string;
  disableBefore?: string;
  disabled?: boolean;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const watchedBeforeDate = useWatch({
    control,
    name: disableBefore || "",
    defaultValue: null,
  });
  
  const minDate = disableBefore && watchedBeforeDate ? dayjs(watchedBeforeDate) : null;

  return (
    <div className="custom-date-picker">
      <Typography.Text>{label}</Typography.Text>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            {...field}
            value={field.value ? dayjs(field.value) : null}
            onChange={(date) => field.onChange(date ? date.toISOString() : "")}
            disabledDate={(date) => {
              if (!date) return false;
              if (minDate && date.isBefore(minDate)) return true;
              return false;
            }}
              format="DD.MM.YYYY"
              disabled={disabled}
              suffixIcon={
                <img src={CalendarIcon} width={24} height={24} alt="icon" />
              }
            className="custom-picker"
          />
        )}
      />
      {errors[name] && (
        <Typography.Text style={{ color: "red" }}>
          {errors[name].message as string}
        </Typography.Text>
      )}
    </div>
  );
};
